import styled from "@emotion/styled";
import { MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH } from "constants/vp-sizes";
export const StyledSideBySideTabsAndProcessTabsDesktopComponent = styled.div`
  max-width: ${`${MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH}px`};
  margin: auto;

  .process-tabs {
    width: 100%;
  }

  .vertical-timer-tabs-container {
    gap: 64px;

    .vertical-timer-tab-desktop-container {
      .vertical-timer-tab-desktop-title-button {
        span {
          font-weight: 600;
        }
      }
    }

    .desktop-tabs-text-container {
      &.tabs-container {
        max-width: 350px;
        min-width: 300px;
        justify-content: flex-start;
        margin-top: 16px;
      }
    }
  }

  .main-title {
    text-align: center;
    font-weight: 600;
  }
`;
